// Футболки лидеров общего зачета: лидер генеральной классификации и лидеры
// категорий мощности. standings — протокол, отсортированный computeStandings,
// по всем участникам (без фильтров), иначе лидером станет первый из отфильтрованных.
// getCategory(standing) — категория, за которую гонщик борется (в RMC — заявленная).
// Футболку получает только тот, кто проехал хотя бы этап: если проездов нет ни у
// кого или ни у кого в категории, футболок нет.
// Возвращает { [user_id]: [{ type: 'gc' } | { type: 'category', category }] }:
// у одного гонщика может быть сразу две футболки — генеральная и категории
export function getLeaderJerseys(standings, getCategory) {
  const jerseys = {};
  const takenCategories = new Set();
  const add = (userId, jersey) => {
    (jerseys[userId] = jerseys[userId] || []).push(jersey);
  };

  (standings || []).forEach((standing, index) => {
    // Без единого проеденного этапа лидером не считается
    if (!standing.routesCompleted) return;

    if (index === 0) add(standing.user_id, { type: 'gc' });

    const category = getCategory(standing);
    if (category && !takenCategories.has(category)) {
      takenCategories.add(category);
      add(standing.user_id, { type: 'category', category });
    }
  });

  return jerseys;
}
